import { Icon, IconName } from '../../ui/Icon/Icon';
import styles from './WorkflowDiagramEntityStep.module.css';

type WorkflowDiagramEntityStepProps = {
  iconName: IconName;
  title: string;
  subtitle: string;
};

export const WorkflowDiagramEntityStep = ({ iconName, title, subtitle }: WorkflowDiagramEntityStepProps) => {
  return (
    <div className={styles.entityStepRoot}>
      <Icon className={styles.entityStepIconContainer} iconName={iconName} />

      <div className={styles.entityStepDescriptionContainer}>
        <span className={styles.entityStepDescriptionTitle}>{title}</span>
        <span className={styles.entityStepDescriptionSubtitle}>{subtitle}</span>
      </div>
    </div>
  );
};
